<template>
  <div class="form-group">
    <label :for="id">{{label}}{{required ? '*' : ''}}: </label>
    <datepicker
      class="form-control"
      :name="name"
      :id="id" :required="required"
      @input="onInput"
      :placeholder="label"
      :language="ru"
      :format="formatter"
      :value="realValue"
    ></datepicker>
  </div>
</template>

<script>
  import { randomString } from '../../utils/string'
  import Datepicker from 'vuejs-datepicker'
  import { ru } from 'vuejs-datepicker/dist/locale'
  import moment from 'moment'

  export default {
    name: 'date-input',
    components: {
      Datepicker
    },
    props: {
      name: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'text'
      },
      id: {
        type: String,
        default: () => {
          return randomString()
        }
      },
      required: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      value: ''
    },
    created () {
      this.realValue = moment(this.value, 'DD.MM.YYYY').toDate()
    },
    data () {
      return {
        ru: ru,
        realValue: ''
      }
    },
    watch: {
      value: (val) => {
        console.log(val)
        this.realValue = moment(val, 'DD.MM.YYYY').toDate()
      }
    },
    methods: {
      onInput ($event) {
        console.log($event)
        this.$emit('input', $event)
      },
      formatter (date) {
        console.log(date)
        return moment(date).format('DD.MM.YYYY')
      }
    }
  }
</script>

<style lang="scss">
  .form-group {
    .vdp-datepicker {
      &.form-control {
        display: inline-block;
        & > div {
          width: 100%;
          height: 100%;

          input {
            width: 100%;
            height: 100%;
            display: inline-block;
            border: none;
          }
        }
      }
    }
    .vdp-datepicker__calendar > div {
      background-color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/DateInput.vue